module.exports = "//static.hsappstatic.net/LearningCenterUI/static-1.32682/images/my-playlists-empty-state.svg"